import React, { useEffect, useState } from 'react';
import { ImageService } from '../../services/imageService';

/** A header picture stored by image id (legacy uploads); renders nothing until it has loaded. */
const HeaderImage: React.FC<{ imageId: string }> = ({ imageId }) => {
  const [imageURL, setImageURL] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    ImageService.getImageURL(imageId)
      .then((url) => { if (alive && url) setImageURL(url); })
      .catch((error) => console.error('Failed to load header image:', error));
    return () => { alive = false; };
  }, [imageId]);

  if (!imageURL) return null;
  // Fills its frame (cropping the edges) so header pictures never leave bars (2026-10-13).
  return <img src={imageURL} alt="" className="w-full h-full object-cover" />;
};

export default HeaderImage;
